// This file is auto-generated by @skynet/data-helpers/scripts/generate-rtk-exports.mjs
// Do not edit manually.

import { hookExports } from './marketing-campaigns-api';

export const useCreateMarketingCampaign: typeof hookExports.useCreateMarketingCampaign =
  hookExports.useCreateMarketingCampaign;
export const useListMarketingCampaigns: typeof hookExports.useListMarketingCampaigns =
  hookExports.useListMarketingCampaigns;
export const useLazyListMarketingCampaigns: typeof hookExports.useLazyListMarketingCampaigns =
  hookExports.useLazyListMarketingCampaigns;
export const useListMarketingSources: typeof hookExports.useListMarketingSources =
  hookExports.useListMarketingSources;
export const useLazyListMarketingSources: typeof hookExports.useLazyListMarketingSources =
  hookExports.useLazyListMarketingSources;
export const useListMarketingMediums: typeof hookExports.useListMarketingMediums =
  hookExports.useListMarketingMediums;
export const useLazyListMarketingMediums: typeof hookExports.useLazyListMarketingMediums =
  hookExports.useLazyListMarketingMediums;
export const useGetMarketingCampaign: typeof hookExports.useGetMarketingCampaign =
  hookExports.useGetMarketingCampaign;
export const useLazyGetMarketingCampaign: typeof hookExports.useLazyGetMarketingCampaign =
  hookExports.useLazyGetMarketingCampaign;
export const useUpdateMarketingCampaign: typeof hookExports.useUpdateMarketingCampaign =
  hookExports.useUpdateMarketingCampaign;
export const useDeleteMarketingCampaign: typeof hookExports.useDeleteMarketingCampaign =
  hookExports.useDeleteMarketingCampaign;
